/**
 * Account deletion. Shmerge has no sign-in — the "account" is the locally
 * stored player profile (name, coins, settings, high score) plus any scores
 * submitted to the leaderboard under that name. Deleting removes both, which
 * satisfies App Store Guideline 5.1.1(v)'s in-app account-deletion requirement.
 */
import { deletePlayerScores, getPlayerName } from './leaderboard';

export interface DeleteAccountResult {
  /** False when the leaderboard API couldn't be reached — local data is wiped regardless. */
  serverCleared: boolean;
}

/** Every persisted key is namespaced 'shmerge.' or 'shmerge-' (e.g. 'shmerge-ui-palette'). */
const STORAGE_PREFIX = 'shmerge';

function wipeLocalData(): void {
  try {
    const doomed: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(STORAGE_PREFIX)) doomed.push(key);
    }
    for (const key of doomed) localStorage.removeItem(key);
  } catch {}
}

/**
 * Deletes the player's leaderboard scores (best effort), then wipes all local
 * data. Callers should reload the page afterwards so every module-level cache
 * (settings, palette, audio, wallet) restarts from a fresh-install state.
 */
export async function deleteAccountData(): Promise<DeleteAccountResult> {
  let serverCleared = true;
  const name = getPlayerName();
  if (name) {
    try {
      await deletePlayerScores(name);
    } catch {
      serverCleared = false;
    }
  }
  wipeLocalData();
  return { serverCleared };
}
